<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">News</div>
            <div class="header-title">新闻动态</div>
        </div>
        <!-- 产品中心 -->
        <div>
            <div class="w" style="padding: 60px 0;" v-html="info.newsContent">
              
            </div>
        </div>
    </div>
</template>

<script>
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            info:{}
        }
    },
    methods: {
      
    },
    mounted() {
        debugger
        let index =  this.$route.query.index;
        let that=this;
        this.http.post("/api/FJ_News/GetNewsById?id="+index,JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
            that.info=objResult.data;
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });



        
    }
}
</script>

<style scoped>
.header {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100%;
}

.bgg{
    background: url('../../assets/img/sdhh.png') no-repeat;
    background-size: 100% 100%;
    height: 450px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.products-item {
    width: 30%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 30px;
    border: 1px solid transparent;
}

.products-item:hover {
    border: 1px solid #0AA00A;
}

.mt-3 {
    margin-top: 30px;
    line-height: 2.0;
    
}

.border {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #eee;
}

.ttitle1 {
    font-size: 16px;
    font-weight: 700;
}

.pp {
    font-size: 16px;
    line-height: 2.0;
}
</style>


// WEBPACK FOOTER //
// src/views/news/detail.vue